module.exports = __webpack_public_path__ + "static/media/top-teachers-video.662123de.mp4";